import { getLatestComics } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';

export default function LatestUpdates() {
  const latestComics = getLatestComics(8);

  return (
    <section className="py-10 md:py-14 px-4 md:px-6 max-w-7xl mx-auto">
      <div className="flex items-center justify-between mb-6 md:mb-8">
        <div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-900">
            <i className="ri-timer-flash-line text-primary-500 mr-2"></i>
            最新更新
          </h2>
          <p className="text-sm text-foreground-500 mt-1">实时更新的漫画章节，追更不再等待</p>
        </div>
      </div>
      <div data-product-shop className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
        {latestComics.map((comic) => {
          const latestChapter = comic.chapters[comic.chapters.length - 1];
          return (
            <div key={comic.id} className="relative">
              <ComicCard comic={comic} />
              <div className="absolute bottom-[72px] left-0 right-0 mx-3">
                <span className="text-[10px] bg-accent-500 text-background-50 px-2 py-0.5 rounded-full whitespace-nowrap">
                  更新至{latestChapter.title}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}